import React from 'react';
import { EventDetailsStatsSection as EventDetailsStatsSectionImpl } from './stats.sections';

export default function EventDetailsStatsSection(props) {
    return <EventDetailsStatsSectionImpl {...props} />;
}
